var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55361 3.18697C1.15571 3.18697 0.832415 3.08523 0.583721 2.88175C0.335036 2.67827 0.210693 2.39115 0.210693 2.02038C0.210693 1.64057 0.332776 1.34666 0.576942 1.13867C0.821108 0.930674 1.14666 0.826675 1.55361 0.826675H12.514C12.921 0.826675 13.2443 0.930674 13.484 1.13867C13.7235 1.34666 13.8433 1.64057 13.8433 2.02038C13.8433 2.39115 13.719 2.67827 13.4704 2.88175C13.2216 3.08523 12.9028 3.18697 12.514 3.18697H1.55361Z",
    fill: "#F9F5EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.f730abdde7650652fc54fcbbecf211d1.svg";
export { ForwardRef as ReactComponent };